import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["Layouts", "onSubmit", "scrollIntoView"];
import { CoreDomainSearchModule, CORE_DOMAIN_SEARCH_TRANSLATIONS_NS } from '@wix/core-domain-search';
import React, { useEffect } from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { scrollToSearchTopTarget } from '../../utils/scrollToSearchTopTarget';
export const SearchBar = _ref => {
  let _ref$Layouts = _ref.Layouts,
    Layouts = _ref$Layouts === void 0 ? {} : _ref$Layouts,
    onSubmit = _ref.onSubmit,
    scrollIntoView = _ref.scrollIntoView,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(() => {
    return () => {
      const _ref2 = getPremiumEssentialsSafe() ?? {},
        i18n = _ref2.i18n;
      const locale = (i18n == null ? void 0 : i18n.language) ?? 'en';
      i18n == null || i18n.removeResourceBundle(locale, CORE_DOMAIN_SEARCH_TRANSLATIONS_NS);
    };
  }, []);
  return /*#__PURE__*/React.createElement(CoreDomainSearchModule.Provider, {
    Layouts: {
      customConfiguration: Layouts
    },
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    }
  }, /*#__PURE__*/React.createElement(CoreDomainSearchModule.SDK.Components.DomainSearchBar, _extends({
    onClear: () => {
      DomainSearchSuiteModule.SDK.domainSearchSuiteStore.resetState();
    },
    onSubmit: filters => {
      DomainSearchSuiteModule.SDK.domainSearchSuiteStore.resetState();
      scrollToSearchTopTarget(scrollIntoView);
      onSubmit == null || onSubmit(filters);
    }
  }, props)));
};
//# sourceMappingURL=SearchBar.js.map